// extracted by mini-css-extract-plugin
export default {"chart":"Chart_chart__0J0WL","btn":"Chart_btn__Kf4Bp","indicators":"Chart_indicators__ejPAf","clock":"Chart_clock__18UBI"};